import React from 'react';

import DemmiIconButton, { IconButtonSize } from '@demmi-ui/IconButton';
import { DemmiFS } from '@subhanhabib/demmilib';

import NotificationOrderNew from './partials/_notificationOrderNew';
import NotificationRefundRequest from './partials/_notificationRefundRequest';

interface Props {
  notifications: DemmiFS.NotificationVendor[];
  onNavigate: () => void;
  onClickClose: () => void;
}

const NotificationsPanelContent: React.FC<Props> = ({
  notifications,
  onNavigate,
  onClickClose,
}) => {
  const CSSBlock = 'notifications-panel-content';

  return (
    <div className={`${CSSBlock}`}>
      <div className={`${CSSBlock}__title`}>Notifications</div>
      <div className={`${CSSBlock}__close-button`}>
        <DemmiIconButton
          faIcon="fa-xmark"
          onClick={() => onClickClose()}
          size={IconButtonSize.SMALL}
        />
      </div>

      <div className={`${CSSBlock}__content`}>
        {notifications.map((notification, i) =>
          [
            DemmiFS.NotificationHelper.Vendor.NotificationType
              .VENDOR_REFUND_REQUEST,
            DemmiFS.NotificationHelper.Vendor.NotificationType
              .VENDOR_REFUND_UPDATE,
          ].includes(notification.type) ? (
            <NotificationRefundRequest
              notification={notification}
              onNavigate={onNavigate}
              key={i}
            />
          ) : (
            <NotificationOrderNew
              notification={notification}
              onNavigate={onNavigate}
              key={i}
            />
          ),
        )}
      </div>
    </div>
  );
};

export default NotificationsPanelContent;
